<div class="paisa-loader">
    <div class="paisa-loader__wrapper">
        <img src="https://images.5paisa.com/login/loader.gif" width="70" height="70" alt="" aria-hidden="true">
    </div>
    <!-- Live region for screen reader announcement -->
    <div role="status" aria-live="assertive" aria-atomic="true">
        <span class="sr-only">{{ loadingMessage }}</span>
    </div>
</div>